export const localStorageData = {
  USER: "user_portal-soporte",
  SETTINGS: "settings_portal-soporte",
  GLOBALES: "globales_portal-soporte",
  AUTH_TOKENS: "authTokens_portal-soporte",
  LAST_INFO: "lastInfo_portal-soporte",
  LOCALE: "locale_portal-soporte",
};

export const cookieConsent = {
  COOKIE_CONSENT_NAME: "cookieConsent_portal-soporte",
};

export const intervals = {
  SESSION_LISTENER: 10000,
};
